import script from "./StoredCard.vue?vue&type=script&setup=true&lang=js"
export * from "./StoredCard.vue?vue&type=script&setup=true&lang=js"

import "./StoredCard.vue?vue&type=style&index=0&id=ddcb78a4&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddcb78a4"]])

export default __exports__